const currencySymbols: { [key: string]: string } = {
  all: 'L', // Albanian Lek
  amd: '֏', // Armenian Dram
  aud: '$', // Australian Dollar
  usd: '$', // US Dollar
  azn: '₼', // Azerbaijani Manat
  bgn: 'лв', // Bulgarian Lev
  chf: 'CHF', // Swiss Franc
  czk: 'Kč', // Czech Koruna
  dkk: 'kr', // Danish Krone
  eur: '€', // Euro
  gbp: '£', // British Pound
  gel: '₾', // Georgian Lari
  ils: '₪', // Israeli Shekel
  isk: 'kr', // Icelandic Krona
  mdl: 'L', // Moldovan Leu
  nok: 'kr', // Norwegian Krone
  pln: 'zł', // Polish Złoty
  ron: 'lei', // Romanian Leu
  rsd: 'дин', // Serbian Dinar
  sek: 'kr', // Swedish Krona
  uah: '₴', // Ukrainian Hryvnia
}

export const currencyDisplay = (currency: string): string => {
  return currencySymbols[currency.toLowerCase()] ?? currency
}

export const replaceCurrencyCodes = (text: string): string => {
  return text.replace(
    /\b[A-Za-z]{3}\b/g,
    (match) => currencySymbols[match.toLowerCase()] ?? match,
  )
}
